export default __webpack_public_path__ + "static/media/subiracuerdoFM.1bc48104.svg";